export enum AutoCompleteDataType {
  investorLevel = 'investor-level',
  corporateLevel = 'corporate-level',
  checks = 'checks-logic',
  standardLocations = 'standard-location',
  locations = 'location',
  adminIndustries = 'industry-admin',
  investors = 'organization-investors',
  stage = 'stage',
  school = 'school',
  source = 'source',
  organizations = 'organization',
  company = 'company',
  roundType = 'round-type',
  person = 'person',
  feature = 'feature',
}

type AutoCompleteOptionArray = Array<AutoCompleteOption>

export type AutoCompleteData = {
  currentPage: number
  count: number
  type: AutoCompleteDataType | string
  data: AutoCompleteOptionArray | Array<any>
}

export type AutoCompleteOption = {
  display: {
    label: string
    extraInfo?: string
  }
  value: any
}

export type AutoCompleteLocationOption = {
  id: string
  fullAddress?: string
  street?: string
  number?: string
  postalCode?: string
  city?: string
  region?: string
  countryCode?: string
  continent?: string
}

export type AutoCompleteIndustryOption = {
  parentId?: string
  id: string
}

export type AutoCompleteInvestorOption = {
  name: string
  type: 'Organization' | 'Person'
}

export type AutoCompleteSchoolOption = {
  name: string
}

export type AutoCompleteOrganizationOption = {
  name: string
  domain: string
}

export type AutoCompleteStageOption = {
  name: string
}
